export default "__VITE_ASSET__CYFwQAgS__"